<script setup lang="ts">
import type { HTMLAttributes } from 'vue'
import { cn } from '@ds/lib/utils'

const props = defineProps<{
  class?: HTMLAttributes['class']
}>()
</script>

<template>
  <div
    :class="cn('flex flex-col gap-y-1.5 px-6 py-4.5', props.class)"
  >
    <slot />
  </div>
</template>
